import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { plantUrls } from "../../URL/ApplicationUrls";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useDeletePlant = (plantId: number | string | undefined | null) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (id: number | undefined | null) => {
      await axios.delete(plantUrls.plantWithId(id).apiUrl);
    },
    onSuccess: async () => {
      toast.success(`Deleting the plant with the Id ${plantId} was successful`);
      navigate(plantUrls.base.uiPath);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
